import PropTypes from 'prop-types';
import './ChartTooltip.scss';

const ChartTooltip = (props) => {
    return (
        <>
            <div id="caret" className="caret">
                <div  className="symbol"></div>
            </div>
            <div className="content">
                <div className="tooltipTitle">{props.title}</div>
                <div className="tooltipBody"> {props.body} </div>
            </div>
        </>
    );
};

ChartTooltip.propTypes = {
    title: PropTypes.string,
    body: PropTypes.any
};

export default ChartTooltip;
